import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Rating from "@mui/material/Rating";
import { getDateTime } from "../../../../../utils/data";

interface Iprops {
  feedbackData: any;
}

const BasicDetails = (props: Iprops) => {
  const { feedbackData } = props;
  return (
    <Accordion
      expanded
      disableGutters
      elevation={0}
      square
      sx={{
        marginTop: "15px",
        border: "1px solid #dbdce0",
        borderRadius: "8px",
        background: "rgba(32, 33, 36, 0.03)",
        "& .MuiAccordionDetails-root": {
          background: "#FFF",
          borderRadius: "0 0 8px 8px",
        },
      }}
    >
      <AccordionSummary
        // expandIcon={<KeyboardArrowUpIcon />}
        aria-controls={"panel1-content"}
        id={"panel1-header"}
        sx={{
          fontFamily: "Poppins",
          fontWeight: 600,
          fontSize: "14px",
        }}
      >
        <Grid
          container
          className="acc-prod-icon"
          justifyContent="space-between"
        >
          <Grid item spacing={2} className="acc-prod-icon">
            Basic Details
          </Grid>
          <Grid
            item
            gap="9px"
            sx={{
              color: "#FA3F3F",
            }}
          >
            {/* <Box display="flex" alignItems="center">
              <span
                style={{
                  position: "relative",
                  top: "7px",
                  marginRight: "9px",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <g clip-path="url(#clip0_1031_2053)">
                    <path
                      d="M4.55513 17.9848L4.88652 17.8922C5.20527 17.8031 5.39145 17.4725 5.30238 17.1537L1.5136 3.59511C1.46013 3.40376 1.33285 3.2415 1.15974 3.144C0.986629 3.04651 0.781881 3.02178 0.590539 3.07525L0.547742 3.0872C0.149267 3.19853 -0.0835081 3.61181 0.0278212 4.01029L3.8167 17.5689C3.90577 17.8876 4.23637 18.0738 4.55513 17.9848Z"
                      fill="#FA3F3F"
                    />
                    <path
                      d="M17.8975 8.5097C16.696 7.9106 15.5844 7.1459 14.5954 6.23797C14.5123 6.16187 14.4797 6.04505 14.5116 5.93694C15.0017 4.083 15.3656 2.19799 15.6009 0.29487C15.6382 -0.0216813 15.4675 -0.114785 15.2875 0.102457C11.7557 4.32625 5.64505 -0.670302 2.00781 3.16866C2.05148 3.25042 2.08583 3.33683 2.11023 3.42625L4.56816 12.2276C8.21161 8.43521 14.3006 13.4007 17.8261 9.18625C18.0061 8.96901 18.0402 8.57177 17.8975 8.5097Z"
                      fill="#FA3F3F"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1031_2053">
                      <rect width="18" height="18" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              Categories of problems
            </Box> */}
          </Grid>
        </Grid>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container mt="13px">
          <Grid item md={4} xs={12}>
            <Typography
              className="title-sm-fb"
            >
              Date & Time
            </Typography>
            <Typography className="info reportstickets">{feedbackData.createdOn ? getDateTime(feedbackData.createdOn) : ""}</Typography>
          </Grid>

          {feedbackData.feedbackCategory &&
            <Grid item md={4} xs={12}>
              {" "}
              <Typography
                className="title-sm-fb"
              >
                Raised Via
              </Typography>
              <Typography className="info reportstickets">{feedbackData.feedbackCategory}</Typography>
            </Grid>
          }
          {
            feedbackData.productRating ?
            (<Grid item md={4} xs={12}>
              {" "}
              <Typography
                className="title-sm-fb"
              >
                Rating
              </Typography>
              <Rating value={feedbackData.productRating} readOnly />
            </Grid>) : <></>
          }

        </Grid>

        {feedbackData.feedbackComments.standardFeedback && feedbackData.feedbackComments.standardFeedback.length > 0 &&
          <Grid container mt="13px">
            <Grid item md={6} xs={12}>
              <Typography
                className="title-sm-fb"
              >
                Standard Feedback
              </Typography>
              <Typography className="info reportstickets">
                {((feedbackData.feedbackComments.standardFeedback).join(", "))}
              </Typography>
            </Grid>
          </Grid>}

        {feedbackData.feedbackComments.generalComment &&
          <Grid container mt="13px">
            <Grid item xs={12}>
              <Typography
                className="title-sm-fb"
              >
                User remarks
              </Typography>
              <Typography className="info reportstickets">
                {feedbackData.feedbackComments.generalComment}
              </Typography>
            </Grid>
          </Grid>}

          {feedbackData && feedbackData["topics"] && feedbackData["topics"].length && 
            <Grid item xs={12}>
              {" "}
              <Typography
                className="title-sm-fb"
              >
                Topics
              </Typography>
              { feedbackData["topics"].map((el: string, i: number) => {
                  return (
                    <Typography className="info reportstickets">
                      {i + 1}. {el}
                    </Typography>
                  );
                })}
            </Grid>}
      </AccordionDetails>
    </Accordion>
  );
};

export default BasicDetails;
